import emailService from "../services/email.service";
import Config from "@config"
import { handleError } from "../services/index.service";


const sendWelcomeEmail = async (email) => {

    console.log('=== currentEmail === email.controller.js === key: 357175 ===');
    console.dir(email, { depth: null, colors: true })
    console.log('=================================');

    if (!email) {
        return { 
            success : false,
            message: "Email is Required",
            fromError: null,
            errorCode: "email-required-error",
            errorKey: 787828,

        }; 
    }

    try {
        const result = await emailService.sendWelcomeEmail(email);
        return result;
    } catch (error) {
      console.log('=== error === email.controller.js === key: 200878 ===');
      console.dir(error, { depth: null, colors: true })
      console.log('=================================');
        return {
            success: false,
            message: "Error envoie email",
            fromError: !Config.IN_PROD ? error : null,
            errorCode: "send-email-error",
            errorKey: 787628,
        }
    }

};

const resendICF = async ({ email, firstname, lastname, participant_id, site_icf_id, consent_id }) => {
  if (!email || !firstname || !lastname || !participant_id || !site_icf_id || !consent_id) {
    return {
      success: false,
      message: "Missing required fields",
      fromError: null,
      errorCode: "resend-icf-fields-missing",
      errorKey: 787829,
    };
  }

  try {
    const result = await emailService.resendICF({
      email,
      firstname,
      lastname,
      participant_id,
      site_icf_id,
      consent_id,
    });
    return result;
  } catch (error) {
    return {
      success: false,
      message: "Error sending ICF email",
      fromError: !Config.IN_PROD ? error : null,
      errorCode: "resend-icf-send-error",
      errorKey: 787630,
    };
  }
};
  


const EmailController = {
    sendWelcomeEmail, 
    resendICF,
};

export default EmailController;